import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  constructor(private router: Router) {}
  ngOnInit(): void {
    const host = window.location.hostname;

    // Check if the host matches any of the portal configurations in environment under portalConfigs
    const portalConfig = environment.portalConfigs.find((config) => config.host === host);
    if (portalConfig) {
      const currentHash = window.location.hash;
      // Don't override deep portal routes (e.g. #/portal/redirect?...) — only redirect
      // to the portal home when landing on the bare domain or the portal root itself.
      const isDeepPortalRoute = /^#\/portal\/.+/.test(currentHash);
      if (!isDeepPortalRoute) {
        // Collect any query params already in the URL (before and within the hash)
        // so that captive-portal params like login=, mac=, ip= are preserved.
        const existingParams: Record<string, string> = {};
        new URLSearchParams(window.location.search).forEach((v, k) => {
          existingParams[k] = v;
        });
        const hashQuery = currentHash.includes('?') ? currentHash.split('?')[1] : '';
        new URLSearchParams(hashQuery).forEach((v, k) => {
          existingParams[k] = v;
        });

        this.router.navigate(['/portal'], {
          queryParams: { ...existingParams, vno: portalConfig.vno }
        });
      }
    }
  }
  title = 'stm-front-base';
}
